// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function normalizeJsonApi(response: any): Record<string, any> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const normalized: Record<string, any> = {};

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const processResource = (resource: any) => {
    if (!normalized[resource.type]) {
      normalized[resource.type] = {};
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const entity: any = {
      id: resource.id,
      ...resource.attributes
    };

    // Convert relationships to top-level arrays
    if (resource.relationships) {
      for (const relKey in resource.relationships) {
        const rel = resource.relationships[relKey];

        if (!rel.data) continue;

        if (Array.isArray(rel.data)) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          entity[relKey] = rel.data.map((r: any) => ({
            id: r.id,
            type: r.type
          }));
        }
        else {
          entity[relKey] = {
            id: rel.data.id,
            type: rel.data.type
          };
        }
      }
    }

    normalized[resource.type][resource.id] = entity;
  };

  if (Array.isArray(response.data)) {
    response.data.forEach(processResource);
  }
  else if (response.data) {
    processResource(response.data);
  }

  if (Array.isArray(response.included)) {
    response.included.forEach(processResource);
  }

  if (response.meta) {
    normalized.meta = response.meta;
  }
  if (response.links) {
    normalized.links = response.links;
  }

  return normalized;
}
